import React from 'react';

import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import ContatoInputText from './ContatoInputText';
import { PlanoContext } from '../Plano';
import { send } from '../../services/mail';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(() => ({
  root: {},
  inputText: {
    margin: '0.25em 0',
    '&:first-child': {
      marginTop: '0.5em',
    },
    '&:last-child': {
      marginBottom: '0.5em',
    },
  },
}));


const ContatoForm: React.FC<{}> = () => {
  const [mensagem, setMensagem] = React.useState('');
  const [usuarioEmail, setUsuarioEmail] = React.useState('');
  const [usuarioNome, setUsuarioNome] = React.useState('');
  const [usuarioTelefone, setUsuarioTelefone] = React.useState('');
  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles();

  const handleChangeMensagem = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMensagem(event.target.value);
  };

  const handleChangeUsuarioEmail = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setUsuarioEmail(event.target.value);
  };

  const handleChangeUsuarioNome = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setUsuarioNome(event.target.value);
  };

  const handleChangeUsuarioTelefone = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setUsuarioTelefone(event.target.value);
  };

  const reset = () => {
    setMensagem('');
    setUsuarioEmail('');
    setUsuarioNome('');
    setUsuarioTelefone('');
  };

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    send(usuarioEmail, usuarioNome, usuarioTelefone, mensagem)
      .then((response) => { // eslint-disable-line @typescript-eslint/no-unused-vars
        enqueueSnackbar(
          'Mensagem enviada com sucesso!',
          {
            variant: 'success',
          },
        );
        reset();
      })
      .catch((err) => { // eslint-disable-line @typescript-eslint/no-unused-vars
        enqueueSnackbar(
          'Ocorreu um erro. Tente novamente mais tarde!',
          {
            variant: 'error',
          },
        );
      });
  };

  const renderInputMensagem = (
    <PlanoContext.Consumer>
      {(context: any) => {
        if (context.mensagemContato.length !== 0) {
          setMensagem(context.mensagemContato);
          context.setMensagemContato('');
        }

        return (
          <ContatoInputText
            id="input-mensagem"
            className={classes.inputText}
            label="Mensagem"
            value={mensagem}
            onChange={handleChangeMensagem}
            required
            multiline
            fullWidth
          />
        );
      }}
    </PlanoContext.Consumer>
  );

  return (
    <form id="form-contato" className={classes.root} onSubmit={submit}>
      <ContatoInputText
        id="input-nome"
        className={classes.inputText}
        label="Nome"
        onChange={handleChangeUsuarioNome}
        value={usuarioNome}
        required
        fullWidth
      />
      <ContatoInputText
        id="input-email"
        className={classes.inputText}
        label="Email"
        onChange={handleChangeUsuarioEmail}
        value={usuarioEmail}
        type="email"
        required
        fullWidth
      />
      <ContatoInputText
        id="input-telefone"
        className={classes.inputText}
        label="Telefone"
        onChange={handleChangeUsuarioTelefone}
        value={usuarioTelefone}
        required
        fullWidth
      />
      {renderInputMensagem}
      <Button variant="contained" color="primary" type="submit" fullWidth>
        Enviar
      </Button>
    </form>
  );
};

export default ContatoForm;